/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_IntroInputs */



/**
* | output |
* | --- |
* | "Tell us what's working, what's broken, or what you'd like to see." |
*
* @param {Feedback_IntroInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_intro = /** @type {((inputs?: Feedback_IntroInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_IntroInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dites-nous ce qui fonctionne, ce qui est cassé, ou ce que vous aimeriez voir.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuéntenos qué funciona, qué está roto o qué le gustaría ver.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nos diga o que está funcionando, o que está errado ou o que você gostaria de ver.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dicci cosa funziona, cosa è rotto o cosa vorresti vedere.")
	return /** @type {LocalizedString} */ ("Tell us what's working, what's broken, or what you'd like to see.")
});